"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Button_1 = require("@components/base/Button");
var ErrorArea_1 = require("@components/case/freeText/ErrorArea");
var RHFInputFields_1 = require("@components/case/freeText/RHFInputFields");
var freeText_1 = require("@domain/freeText");
var useFreeText_1 = require("./useFreeText");
require("rsuite/dist/rsuite.min.css");
/**
 * 自由記述フォーム
 * @return {*}
 */
var Index = function () {
    var _a = (0, useFreeText_1.useFreeText)(), isError = _a.isError, errors = _a.errors, scenarioContentItems = _a.scenarioContentItems, handleSubmit = _a.handleSubmit, onSubmit = _a.onSubmit, getLabel = _a.getLabel, control = _a.control, isLoading = _a.isLoading, isValid = _a.isValid, watchAllFields = _a.watchAllFields;
    return isError ? ((0, jsx_runtime_1.jsx)(ErrorArea_1.ErrorArea, {})) : ((0, jsx_runtime_1.jsx)(Box_1.default, { sx: { pt: 5, pb: 3, px: 2, maxWidth: "600px", margin: "auto" }, children: (0, jsx_runtime_1.jsxs)("form", { id: "freeTextForm", onSubmit: handleSubmit(onSubmit), style: { width: "100%", paddingBottom: "32px" }, children: [scenarioContentItems.map(function (scenarioContentItem) {
                    var _a;
                    if (!scenarioContentItem.id)
                        return null;
                    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { sx: {
                            pb: 5,
                            "& .MuiFormHelperText-root.Mui-error": { display: "none" },
                            "& .MuiTypography-root.MuiTypography-caption.custom-datetime-error": { display: "none" },
                            "& .MuiTypography-caption": {
                                fontSize: "10px",
                                mt: "3px",
                                display: "block",
                            },
                            "& .rs-picker .rs-picker-toggle-caret": { color: "#6B83A0" },
                            "& .MuiOutlinedInput-root": { fontSize: "16px" },
                            "& .MuiOutlinedInput-root textarea::placeholder": {
                                color: "#8DA3BE",
                                opacity: 1,
                            },
                            "& .MuiOutlinedInput-root input::placeholder": {
                                color: "#8DA3BE",
                                opacity: 1,
                            },
                        }, children: [(0, jsx_runtime_1.jsx)(RHFInputFields_1.RHFInputFields, __assign({ itemType: scenarioContentItem.data, name: scenarioContentItem.id.toString(), label: getLabel(scenarioContentItem.isRequired, scenarioContentItem.itemTitle), placeholder: (0, freeText_1.getPlaceholder)(scenarioContentItem.data), validationRules: (0, freeText_1.validationRules)(scenarioContentItem.isRequired), rows: scenarioContentItem.data === "textarea" ? 5 : 1, control: control }, (scenarioContentItem.data === "datetime-local"
                                ? { disablePast: false }
                                : {})), scenarioContentItem.id), (0, jsx_runtime_1.jsxs)(Box_1.default, { sx: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }, children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "caption", fontWeight: 500, lineHeight: "14px", style: { wordWrap: "break-word", wordBreak: "break-all" }, color: "#8DA3BE", children: scenarioContentItem.example }), (0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "caption", fontWeight: 600, color: "#ff0000", children: (_a = errors[scenarioContentItem.id]) === null || _a === void 0 ? void 0 : _a.message })] })] }, scenarioContentItem.id));
                }), (0, jsx_runtime_1.jsx)(Box_1.default, { sx: {
                        pt: 2,
                        pb: 3,
                        position: "fixed",
                        width: "calc(100% - 32px)",
                        bottom: 0,
                        left: "16px",
                        zIndex: 100,
                        background: "#fff",
                        "& button": { fontSize: "16px", width: "100%" },
                    }, children: (0, jsx_runtime_1.jsx)(Box_1.default, { sx: { maxWidth: "600px", margin: "auto" }, children: (0, jsx_runtime_1.jsx)(Button_1.ButtonLarge, { disabled: (0, freeText_1.isDisabled)(isValid, isLoading, errors, (0, freeText_1.getIsInput)(scenarioContentItems, watchAllFields)), type: "submit", form: "freeTextForm", children: "\u56DE\u7B54\u3092\u9001\u4FE1" }) }) })] }) }));
};
// eslint-disable-next-line import/no-default-export -- 暫定対応
exports.default = Index;
